import clsx from 'clsx';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import SearchField from '@/common/components/search-field/SearchField';

import './SearchForm.less';

function SearchForm({ className, value, placeholder, onChange, onFocus, onSubmit }, fwdRef) {
    const text = value || '';
    const ref = useRef();
    useImperativeHandle(fwdRef, () => ({ focus: () => ref.current.focus() }));
    function change(value) {
        if (onChange) onChange(value);
    }
    function focus() {
        if (onFocus) onFocus(text);
    }
    function submit(e) {
        e.preventDefault();
        if (onSubmit) onSubmit(text);
    }
    return (
        <form className={clsx('search-form', className)} onSubmit={submit}>
            <SearchField ref={ref} value={text} placeholder={placeholder} onChange={change} onFocus={focus} />
        </form>
    );
}
export default forwardRef(SearchForm);
